export enum CompilationError {
    MissingIdentity = "The user identity couldn't be resolved",
    MissingFreeWallConfig = "The FreeWall configuration couldn't be found in the resource folders",
}
